// src/component/Account/tabs/NotificationsTab.jsx
import React, { useEffect, useState } from "react";
import { accountService } from "../../../services/accountService";

export default function NotificationsTab() {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  const load = async () => {
    setLoading(true);
    const data = await accountService.getNotifications();
    setRows(data);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await accountService.markNotificationRead(id);
    await load();
  };

  return (
    <section className="acc-panel">
      <h2 className="acc-title">Notifications</h2>

      <ul className="acc-list">
        {loading
          ? Array.from({ length: 3 }).map((_, i) => <li key={i} className="skel skel-line" />)
          : rows.map(n => (
              <li key={n.id} className={`acc-note ${n.read ? "is-read" : ""}`}>
                <div className="acc-noteTitle">{n.title}</div>
                <div className="acc-noteBody">{n.body}</div>
                {!n.read && (
                  <button className="acc-btn sm" onClick={() => markRead(n.id)}>Marquer comme lue</button>
                )}
              </li>
            ))}
      </ul>
    </section>
  );
}
